export var setCookiebotLoaded = function setCookiebotLoaded(state, value) {
  state.cookiebotLoaded = value;
};
export var setSafeCookiebotMethod = function setSafeCookiebotMethod(state, method) {
  state.safeCookiebotMethod = method;
};
export var setCookiebotFailed = function setCookiebotFailed(state, value) {
  state.cookiebotFailed = value;
};